import { render, staticRenderFns } from "./Responded.vue?vue&type=template&id=a53e1a6c&scoped=true"
import script from "./Responded.vue?vue&type=script&lang=js"
export * from "./Responded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53e1a6c",
  null
  
)

export default component.exports